import { Link } from "react-router-dom";
import RichText from "@/components/RichText";
import { CONTAINER, FOOTER_BG, FOOTER_RULE, FOOTER_TEXT, FOOTER_TEXT_HOVER, FOOTER_VARS } from "../tokens";

// Pied de page du handoff : un filet, une ligne, rien de plus — mention de
// copyright poussée à gauche, liens à droite. Fond et textes suivent les
// couleurs de ZONE « Pied de page » du Studio (voir FOOTER_VARS).
export default function SiteFooter({ props = {}, blocks = [] }) {
  if (String(props.hide_entire_footer) === "true") return null;
  const links = (blocks || [])
    .filter((b) => b.type === "link_item" && b.enabled !== false && b.props?.label)
    .map((b) => ({ id: b.id, label: b.props.label, url: b.props.url || "" }));

  return (
    <footer className={`border-t ${FOOTER_RULE} ${FOOTER_BG}`} style={FOOTER_VARS} data-testid="agence-footer">
      <div className={`${CONTAINER} py-[26px] flex flex-wrap gap-4 items-center text-[13.5px] ${FOOTER_TEXT}`}>
        <RichText className="me-auto" html={props.copyright} />
        {links.map((l) =>
          !l.url ? (
            <span key={l.id}>{l.label}</span>
          ) : l.url.startsWith("#") || l.url.startsWith("http") ? (
            // min-h 24px + padding vertical : ces liens mesuraient moins de
            // 24 px de haut (audit du 09/09/2026, WCAG 2.2). La zone
            // cliquable s'élargit sans que la taille du texte bouge, donc le
            // pied de page garde exactement son apparence.
            <a
              key={l.id}
              href={l.url}
              className={`inline-flex items-center min-h-[24px] py-1 ${FOOTER_TEXT_HOVER} transition-colors duration-150`}
            >
              {l.label}
            </a>
          ) : (
            <Link key={l.id} to={l.url} className={`${FOOTER_TEXT_HOVER} transition-colors duration-150`}>
              {l.label}
            </Link>
          )
        )}
      </div>
    </footer>
  );
}
